export default {"src":"/_next/static/media/facebook.1acfc570.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};